import ModernTabs from '../../common/Tabs/ModernTabs';
import SubHeader from '../../layout/components/SubHeader'
import EmailTemplates from './tabs/EmailTemplates';
import SmsTemplates from './tabs/SmsTemplates';
import CallTemplates from './tabs/CallTemplates';
import Overview from './tabs/Overview';
const Templates = () => {
    const tabContent = [

        {
            id: 'overview',
            label: 'Warning',
            icon: 'dashboard',
            content: <Overview />
        },
        {
            id: 'email',
            label: 'Email Templates',
            icon: 'email',
            content: <EmailTemplates />
        },
        {
            id: 'sms',
            label: 'SMS Templates',
            icon: 'sms',
            content: <SmsTemplates />
        },{
            id: 'call',
            label: 'Call Demos',
            icon: 'call',
            content: <CallTemplates />
        }
    ];
    
    return (
        <div>
            <SubHeader title="Templates" description="Manage your email, SMS, and call templates" />
            <ModernTabs orientation="horizontal" tabs={tabContent}  />
        </div>
    );
};

export default Templates;